import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { generateSkeletonKey } from '../../../helpers/commonHelper';
import ActivityFeedLoader from '../../shared/SkeletonLoaders/ActivityFeedLoader/ActivityFeedLoader';
import JobFeedItemLoader from '../../shared/SkeletonLoaders/JobFeedItemLoader/JobFeedItemLoader';
import LeaderboardItemLoader from '../../shared/SkeletonLoaders/LeaderboardItemLoader/LeaderboardItemLoader';
import StatCardLoader from '../../shared/SkeletonLoaders/StatCardLoader/StatCardLoader';

import 'react-loading-skeleton/dist/skeleton.css';

const DashboardLoader = () => (
  <div className="min-h-screen bg-gray-50 p-4 sm:p-5 md:p-[26px]">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[16px]">
      {/* Left Column */}
      <div className="space-y-4 md:col-span-2 lg:col-span-1 order-1 md:order-1">
        {/* Profile Card */}
        <div className="bg-white rounded-xl shadow-card p-3 sm:p-4">
          <div className="flex items-center gap-3">
            <Skeleton circle width={40} height={40} />
            <div className="flex-1">
              <Skeleton width="80%" height={16} className="mb-1" />
              <Skeleton width="60%" height={8} />
            </div>
          </div>
        </div>

        {/* Activity Feed - Desktop */}
        <div className="hidden lg:block">
          <ActivityFeedLoader itemCount={6} />
        </div>
      </div>

      {/* Middle Column */}
      <div className="md:col-span-2 order-3 md:order-2">
        <div className="bg-white rounded-xl shadow-card">
          <div className="p-3 sm:p-4">
            <Skeleton width="15%" height={16} />
            <div className="grid grid-cols-9 gap-3">
              <Skeleton width="100%" height={8} />
              <Skeleton width="100%" height={8} />
              <Skeleton width="100%" height={8} />
            </div>

            {/* Desktop Feed */}
            <div className="space-y-4 pt-2">
              {[...Array(9)].map((_, idx) => (
                <JobFeedItemLoader key={generateSkeletonKey('job', idx)} />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Activity Feed - Mobile */}
      <div className="block lg:hidden order-2 md:order-3 md:col-span-2">
        <ActivityFeedLoader itemCount={6} />
      </div>

      {/* Right Column */}
      <div className="space-y-4 md:col-span-2 lg:col-span-1 order-4">
        {/* Referral Link Card */}
        <div className="bg-white rounded-lg p-3 sm:p-4 shadow-card">
          <Skeleton width="40%" height={16} className="mb-1.5" />
          <div className="gap-2 border border-gray-300 rounded-lg px-[14px] py-2">
            <Skeleton width="85%" height={20} />
          </div>
        </div>

        {/* Stats Overview */}
        <div className="grid grid-cols-2 gap-3 bg-white rounded-lg p-3 shadow-card">
          {[...Array(4)].map((_, idx) => (
            <StatCardLoader key={generateSkeletonKey('stat', idx)} />
          ))}
        </div>

        {/* Leaderboard */}
        <div className="bg-white rounded-xl shadow-card p-3 sm:p-4">
          <Skeleton width="40%" height={16} className="mb-[16px]" />
          <div className="space-y-3">
            {[...Array(6)].map((_, idx) => (
              <LeaderboardItemLoader key={generateSkeletonKey('leaderboard', idx)} />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DashboardLoader;
